﻿(function () {
  'use strict';

  var rootSelector = '[data-bf-preserved-quick-add]';
  var requestUrl = 'https://bloomingful-back-in-stock.onrender.com/api/back-in-stock/requests';

  function asNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function variantFromControl(root) {
    var control = root.querySelector('[data-bf-preserved-variant-select]');
    if (!control) return null;
    var option = control.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
    if (!option) return null;
    return {
      id: control.value || option.value,
      title: option.getAttribute('data-variant-title') || option.textContent || '',
      sku: option.getAttribute('data-variant-sku') || '',
      price: asNumber(option.getAttribute('data-variant-price')) || 0,
      available: option.getAttribute('data-available') === 'true',
      inventoryItemId: option.getAttribute('data-inventory-item-id') || '',
      inventoryManagement: option.getAttribute('data-inventory-management') || '',
      inventoryPolicy: option.getAttribute('data-inventory-policy') || '',
      inventoryQuantity: asNumber(option.getAttribute('data-inventory-quantity')) || 0
    };
  }

  function showNotice(root, text) {
    var element = root.querySelector('[data-bf-preserved-notice]');
    if (!element) return;
    element.textContent = text || '';
    element.hidden = !text;
  }

  function maxForVariant(variant) {
    if (!variant || !variant.available) return 0;
    if (!variant.inventoryManagement || variant.inventoryPolicy === 'continue') return null;
    return Math.max(0, variant.inventoryQuantity || 0);
  }

  function capQuantity(root, showMessage) {
    var input = root.querySelector('[data-bf-preserved-quantity]');
    var variant = variantFromControl(root);
    var max = maxForVariant(variant);
    if (!input) return;
    input.min = '1';
    if (max === null) {
      input.removeAttribute('max');
      input.removeAttribute('data-bf-max-quantity');
      if (!showMessage) showNotice(root, '');
      return;
    }
    input.max = String(max);
    input.setAttribute('data-bf-max-quantity', String(max));
    var current = asNumber(input.value);
    if (current === null || current < 1) {
      input.value = '1';
      current = 1;
    }
    if (max > 0 && current > max) {
      input.value = String(max);
      showNotice(root, 'Only ' + max + ' available.');
    } else if (showMessage && max > 0 && current >= max) {
      showNotice(root, 'Only ' + max + ' available.');
    } else if (!showMessage) {
      showNotice(root, '');
    }
  }

  function syncPricingState(root, variant) {
    var card = root && root.closest ? root.closest('.grid-product') : null;
    var quantityInput = root && root.querySelector('[data-bf-preserved-quantity]');
    if (!card || !variant) return;
    card.setAttribute('data-bf-wsaio-variant-id', String(variant.id || ''));
    card.setAttribute('data-bf-wsaio-variant-sku', String(variant.sku || ''));
    if (variant.price) card.setAttribute('data-bf-wsaio-variant-price', String(variant.price));
    document.dispatchEvent(new CustomEvent('bloomingful:collection-variant-changed', {
      detail: {
        card: card,
        productId: card.getAttribute('data-product-id') || '',
        variantId: String(variant.id || ''),
        quantity: Number(quantityInput && quantityInput.value) || 1
      }
    }));
  }

  function syncBis(root, variant) {
    var bisForm = root.querySelector('[data-bf-preserved-bis-form]');
    if (!bisForm || !variant) return;
    var variantInput = bisForm.querySelector('[data-bf-preserved-bis-variant-id]');
    var inventoryInput = bisForm.querySelector('[data-bf-preserved-bis-inventory-item-id]');
    var titleInput = bisForm.querySelector('[data-bf-preserved-bis-variant-title]');
    if (variantInput) variantInput.value = variant.id;
    if (inventoryInput) inventoryInput.value = variant.inventoryItemId;
    if (titleInput) titleInput.value = variant.title;
  }

  function refresh(root) {
    var variant = variantFromControl(root);
    var addForm = root.querySelector('[data-bf-preserved-quick-add-form]');
    var bisForm = root.querySelector('[data-bf-preserved-bis-form]');
    var submit = root.querySelector('[data-bf-preserved-submit]');
    var available = Boolean(variant && variant.available);
    syncPricingState(root, variant);
    syncBis(root, variant);
    if (addForm) addForm.hidden = !available;
    if (bisForm) bisForm.hidden = available;
    if (submit) submit.disabled = !available;
    capQuantity(root, false);
  }

  function init(root) {
    if (!root || root.dataset.bfPreservedQuickAddReady) return;
    root.dataset.bfPreservedQuickAddReady = 'true';
    var addForm = root.querySelector('[data-bf-preserved-quick-add-form]');
    var bisForm = root.querySelector('[data-bf-preserved-bis-form]');
    var variantControl = root.querySelector('[data-bf-preserved-variant-select]');
    var quantityInput = root.querySelector('[data-bf-preserved-quantity]');

    if (variantControl) {
      variantControl.addEventListener('change', function () { refresh(root); });
    }
    if (quantityInput) {
      quantityInput.addEventListener('input', function () {
        capQuantity(root, true);
        syncPricingState(root, variantFromControl(root));
      });
      quantityInput.addEventListener('change', function () {
        capQuantity(root, true);
        syncPricingState(root, variantFromControl(root));
      });
    }
    if (addForm) {
      addForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var variant = variantFromControl(root);
        var submit = root.querySelector('[data-bf-preserved-submit]');
        if (!variant || !variant.available) {
          refresh(root);
          return;
        }
        capQuantity(root, true);
        if (submit) {
          submit.disabled = true;
          submit.classList.add('is-loading');
        }
        showNotice(root, 'Adding...');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(variant.id), quantity: Number(quantityInput && quantityInput.value) || 1 })
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add this item.');
              return payload;
            });
          })
          .then(function (payload) {
            showNotice(root, 'Added to cart.');
            addForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: payload, addToCartBtn: submit } }));
          })
          .catch(function (error) { showNotice(root, error.message || 'Could not add this item.'); })
          .finally(function () {
            if (submit) {
              submit.disabled = false;
              submit.classList.remove('is-loading');
            }
          });
      });
    }
    if (bisForm) {
      bisForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var status = bisForm.querySelector('[data-bf-preserved-bis-status]');
        var button = bisForm.querySelector('button[type="submit"]');
        var data = Object.fromEntries(new FormData(bisForm).entries());
        if (status) status.textContent = 'Saving your request...';
        if (button) button.disabled = true;
        fetch(requestUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok || !payload.ok) throw new Error(payload.error || 'Could not save request.');
              return payload;
            });
          })
          .then(function () {
            if (status) status.textContent = 'You are on the list. We will email you when this is back in stock.';
            var email = bisForm.querySelector('input[name="email"]');
            if (email) email.value = '';
          })
          .catch(function (error) { if (status) status.textContent = error.message || 'Could not save request.'; })
          .finally(function () { if (button) button.disabled = false; });
      });
    }
    refresh(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(rootSelector).forEach(init);
  }

  var initTimer = null;
  function scheduleInit() {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(function () { initAll(document); }, 100);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('collection:rebuilt', scheduleInit);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  new MutationObserver(scheduleInit).observe(document.documentElement, { childList: true, subtree: true });
}());
